import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import classNames from "classnames";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const InfoEditor = (props) => {
  const { rawState, handleSaveStory } = props;
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    let state;
    if (rawState) state = EditorState.createWithContent(convertFromRaw(rawState));
    else state = EditorState.createEmpty();
    setEditorState(state);
  }, [rawState]);
  const onEditorStateChange = (state) => setEditorState(state);
  return (
    <Editor
      editorState={editorState}
      placeholder="Type in your story here..."
      toolbar={{
        options: ["inline", "textAlign", "link", "image"],
        inline: { options: ["bold", "italic", "underline"] },
        image: {
          urlEnabled: true,
          uploadEnabled: true,
          alignmentEnabled: true,
          previewImage: true,
          inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg",
          alt: { present: false, mandatory: false },
          defaultSize: {
            height: "auto",
            width: "auto",
          },
        },
      }}
      onFocus={() => setIsFocused(true)}
      editorClassName={classNames({ "rdw-editor-main--focused": isFocused })}
      onBlur={(e) => {
        setIsFocused(false);
        const story = convertToRaw(editorState.getCurrentContent());
        if (handleSaveStory) handleSaveStory(story);
      }}
      onEditorStateChange={onEditorStateChange}
    />
  );
};

export default InfoEditor;
